import * as React from "react";

import { TextLineStateless } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/text-line/main/template/text-line.tpl.view";
import { TextLineStatelessProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/text-line/main/template/text-line.tpl.api";

import { ControlContext } from "../../processFormEngine/components/contexts";

export function EpayblAmountInput(props: TextLineStatelessProps): React.ReactNode {
	const { onEpayblAmountChange } = React.useContext(ControlContext);
	return onEpayblAmountChange && !props.readonly && !props.disabled ? (
		<LiveAmountInput {...props} onAmountChange={onEpayblAmountChange} />
	) : (
		<TextLineStateless {...props} />
	);
}

function LiveAmountInput(
	props: TextLineStatelessProps & { onAmountChange: (value: string) => boolean }
): React.ReactNode {
	const { onAmountChange, ...inputProps } = props;
	const [buffer, setBuffer] = React.useState<string>();
	const [invalid, setInvalid] = React.useState(false);
	return (
		<TextLineStateless
			{...inputProps}
			value={buffer ?? props.value}
			onChange={event => {
				setBuffer(event.target.value);
				setInvalid(onAmountChange(event.target.value) === false);
			}}
			onBlur={() => {
				if (!invalid) {
					setBuffer(undefined);
				}
			}}
			onKeyDown={event => {
				if (event.key === "Enter") {
					event.preventDefault();
				} else {
					props.onKeyDown?.(event);
				}
			}}
		/>
	);
}
